// const FC_PW = '26g7bmiug24f3xzqbqcpgjja'
const FC_PW = 'erdf4ph675mfe66gnw8z9num'
const BUY_BUTTON_CLASS = 'js-product-buy-button'
const AUTH_GUARD_CLASS = 'js-fc-authguard'
const primaryLocale = 'ja'

const FC_ORIGINS = {
  stg: 'https://stg-imase.plusmember.jp/',
  prod: 'https://www.imase-official.com/'
}

const FC_AUTH_URLS = {
  stg: 'https://stg-secure.plusmember.jp/imase/1/login/',
  prod: 'https://secure.plusmember.jp/imase/1/login/'
}

const REFERER_URLS = [
  ...Object.values(FC_ORIGINS),
]

const FC_AUTH_URL = Shopify.theme.name.includes('[STG]') ? FC_AUTH_URLS.stg : FC_AUTH_URLS.prod

// セッションストレージに設定された言語にリダイレクト
const redirectToLocale = () => {
  const sessionLocale = sessionStorage.getItem('locale')
  if ((!sessionLocale || sessionLocale === "")) return

  const { isPrimaryLocale, locale } = window.variantStrings

  if(sessionLocale === locale) return

  const { pathname, origin, search } = window.location
  const pathnames = pathname.split('/')

  if(isPrimaryLocale) {
    pathnames[1] = `${sessionLocale}/${pathnames[1]}`
  }
  else if(sessionLocale === primaryLocale) {
    pathnames.splice(1, 1)
  }
  else {
    pathnames[1] = sessionLocale
  }
  
  const newPathname = pathnames.join('/')
  
  const redirectUrl = `${origin}${newPathname}${search}`

  console.log('redirectUrl: ', redirectUrl)

  // セッションストレージをリセット
  sessionStorage.removeItem('locale')

  window.location.href = redirectUrl
}

// ファンクラブ経由どうかを判定する関数（参照元URLとクエリパラメータのパスワードで判定）
function isFanclubReferer() {
  // セッションストレージの認証ステータスを確認する
  const authStatus = sessionStorage.getItem('fanclub_auth_status')
  if (authStatus === 'authenticated') {
    return true
  }

  const urlParams = new URLSearchParams(window.location.search)
  const password = urlParams.get('link_pw')

  // パスワードが一致し、参照元URLが指定されたURLと一致する場合
  if (REFERER_URLS.includes(document.referrer) && password === FC_PW) {
    // セッションストレージに認証ステータスを保存
    sessionStorage.setItem('fanclub_auth_status', 'authenticated')
    return true
  }
  return false
}

isFanclubReferer()

// ファンクラブ認証ガードが有効になっている商品ページの場合は、認証済みかを判定して購入ボタンをファンクラブログインページへのaタグに書き換える
function handleFanclubAuthGuard() {
  const authGuard = document.querySelector(`.${AUTH_GUARD_CLASS}`)
  if (!authGuard) return
  redirectToLocale()

  // 認証ガードが有効な場合は、認証済みかを判定して購入ボタンをファンクラブログインページへのaタグに書き換える
  if (isFanclubReferer()) return
  
  
  // 認証が通らかなった場合は「FC認証」ボタンのaタグにする
  const buyButtons = document.getElementsByClassName(BUY_BUTTON_CLASS)

  Array.from(buyButtons).forEach((buyButton) => {
    const redirectUrl = encodeURIComponent(window.fc_auth_url)
    const { locale } = window.variantStrings

    const aTag = document.createElement('a')
    aTag.href = `${FC_AUTH_URL}?url=${redirectUrl}&lang=${locale}`
    aTag.className = buyButton.className
    aTag.textContent = window.variantStrings.fanclubAuth
    buyButton.parentNode.replaceChild(aTag, buyButton)
    buyButton.remove()

    aTag.onclick = (e) => {
      sessionStorage.setItem('locale', locale)
    }

  })
    
}

handleFanclubAuthGuard()
